import BaseEntity from './BaseEntity';
export default class File extends BaseEntity {
    constructor(data) {
        super();
        this.messages = [];
        this.errorCount = this.parseProperty(data, 'errorCount');
        this.fileId = this.parseProperty(data, 'fileId');
        this.path = this.parseProperty(data, 'path');
        this.warningCount = this.parseProperty(data, 'warningCount');
        if ('messages' in data) {
            this.messages = this.parseProperty(data, 'messages');
        }
    }
}
